<template>
  <div class="container">
    <el-steps direction="vertical" :active="3" align-center>
      <!-- Step 1 -->
      <el-step title="Get DSN key">
        <template slot="description">
          <div class="description">
            <el-tag class="dsn" v-clipboard:copy="dsn" v-clipboard:success="copyDsnSuccess">
              {{ dsn }}
              <i class="fas el-icon-fa-copy" />
            </el-tag>
            <div v-if="isPublic">
              <br />You can use this generated trial key (public and limited number of payloads).
              <br />
              <a
                href="mailto:po@drhttp.com"
              >Ask for a private account if you want extended features.</a>
            </div>
          </div>
        </template>
      </el-step>
      <!-- Step 2 -->
      <el-step title="Install library on your servers">
        <template slot="description">
          <SdksList class="description" />
        </template>
      </el-step>
      <!-- Step 3 -->
      <el-step title="See HTTP payloads">
        <template slot="description">
          <div class="description watch">
            <el-button
              type="primary"
              icon="fas el-icon-fa-stream"
              @click="watchClicked"
            >Watch live data</el-button>
          </div>
        </template>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
import SdksList from "@/components/SdksList.vue";

export default {
  components: {
    SdksList
  },
  props: {
    api_key: {
      required: true
    },
    isPublic: {
      default: true
    }
  },
  computed: {
    dsn: function() {
      return (
        "https://" + this.api_key + "@" + process.env.VUE_APP_API_URL + "/"
      );
    }
  },
  methods: {
    copyDsnKeySuccess() {
      this.$message({
        message: "DSN copied successfully",
        type: "success",
        duration: 1500
      });
    },
    watchClicked() {
      // The comparison with current route is ugly and should be replaced by a cleaner mechanism
      const targetRoute = {
        name: "project",
        params: { api_key: this.api_key }
      };
      if (
        this.$route.name === targetRoute.name &&
        this.$route.params.api_key === targetRoute.params.api_key
      ) {
        // In the case of already being on the project's page, we want to force a refresh of the page since we
        // may be only a child of `Project` component
        this.$router.go(); // refreshes the page
      } else {
        // In the case of comming from out of `Project` which is currenlty comming from the landing page when not logged in
        // we just want to show the `Project`
        this.$router.push(targetRoute);
      }
    }
  }
};
</script>

<style scoped lang="sass">

.container
  @include flex($h: center, $v: center)
  
.dsn
  cursor: copy

.description
  @include margin($v: 20px)

.watch
  @include flex($h: center, $v: center)

</style>